import { combineReducers } from 'redux';
import { STREAM_TYPE_SET, STREAMS_TAB_VALUE_SET } from '../../constants/stream';

const streamTab = (state = 'all', action) => {
    if (action.type === STREAMS_TAB_VALUE_SET) {
        return action.value;
    }

    return state;
};

const streamType = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case STREAM_TYPE_SET:
        return {
            value: action.value,
        };
    default:
        return state;
    }
};

export default combineReducers({
    streamTab,
    streamType,
});
